// eslint-disable react/jsx-props-no-spreading
import React from 'react';
import { PersonAutocompleteInput } from './PersonAutocompleteInput';
import { BaseInputProps, SimpleBlock, useFormContext } from 'ui-builder';
import { ContactSearchResult, PersonPhoneNumber, useContactsSearchService, } from 'nekst-api';
import { useFubConnectionContext } from '../../../Integrations';

import styles from './SearchContactTextInput.module.scss';

export interface SearchContactTextInputProps extends BaseInputProps {
  searchLocalDatabase?: boolean;
}

function useContactsSearch(searchLocalDatabase = true) {

  const contactsSearchService = useContactsSearchService();

  const fubConnectionContext = useFubConnectionContext();

  const profiles = fubConnectionContext?.profiles ?? [];

  const search = async (query: string) => {

    const connectionProfilesIds = [
      ...searchLocalDatabase ? [0] : [],
      ...(fubConnectionContext?.profiles.map((item) => item.id) || [])
    ];

    if (connectionProfilesIds.length > 0) {
      const contacts = await contactsSearchService.searchContacts(
        {
          name: query
        },
        connectionProfilesIds
      );

      const showIcons = profiles.length > 0;

      let result = contacts
        .map((contact) => ({
          ...contact,
          label: contact.name.fullName,
          labelIcon: showIcons ?
            <SimpleBlock className={`${styles.icon} ${styles[contact.source]}`} /> : undefined
        }));

      if (!searchLocalDatabase) {
        result = result.filter((contact) => !contact.personId);
      }

      return result;
    } else {
      return [];
    }
  };

  return {
    search,
    fubConnectionLoaded: fubConnectionContext?.loaded,
  };
}

export default function SearchContactTextInput(props: SearchContactTextInputProps) {
  const formContext = useFormContext();

  const searchLocalDatabase = props.searchLocalDatabase !== undefined ? props.searchLocalDatabase : true;

  const searchService = useContactsSearch(searchLocalDatabase);

  const onChangeCallback = (event: any) => {
    formContext.onChangeCallback!({
      [props.source]: event.target.value,
      personId: null,
      'profile.phoneNumbers': (formContext.data?.profile?.phoneNumbers || []).map((phoneNumber: PersonPhoneNumber) => {
        return {
          ...phoneNumber,
          id: undefined,
        };
      }),
    });
  };

  const selectOptionFunc = (option: ContactSearchResult) => {
    const currentData = formContext.data!;

    const newFormData = {
      personId: option.personId,
      externalLinks: option.externalLinks,
      profile: {
        name: option.name,
        companyName: option.companyName,
        primaryEmail: option.primaryEmail,
        alternateEmail: option.alternateEmail,
        phoneNumbers: option.phoneNumbers || [],
        address: option.address,
      },
      rolesIds: currentData.rolesIds || [],
    };

    formContext.setFormData!(newFormData);
  };

  return (
    <PersonAutocompleteInput<ContactSearchResult & { label: string }>
      {...props}
      loadSuggestions={searchService.search}
      onChangeCallback={onChangeCallback}
      selectOptionFunc={selectOptionFunc}
      dependencies={[searchService.fubConnectionLoaded]}
    />
  );
}
